// source: jkf-board/board-atom/atom.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.atom.AdsInfo', null, global);
goog.exportSymbol('proto.atom.Conditions', null, global);
goog.exportSymbol('proto.atom.ConditionsInfo', null, global);
goog.exportSymbol('proto.atom.ConditionsType', null, global);
goog.exportSymbol('proto.atom.EntityInfo', null, global);
goog.exportSymbol('proto.atom.JobStatus', null, global);
goog.exportSymbol('proto.atom.JobTime', null, global);
goog.exportSymbol('proto.atom.JobType', null, global);
goog.exportSymbol('proto.atom.Limit', null, global);
goog.exportSymbol('proto.atom.LiveJobInfo', null, global);
goog.exportSymbol('proto.atom.LiveTeam', null, global);
goog.exportSymbol('proto.atom.PersonalJobType', null, global);
goog.exportSymbol('proto.atom.PostPicType', null, global);
goog.exportSymbol('proto.atom.PriceType', null, global);
goog.exportSymbol('proto.atom.SelectedLadyInfo', null, global);
goog.exportSymbol('proto.atom.Team', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.Conditions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.atom.Conditions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.Conditions.displayName = 'proto.atom.Conditions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.JobTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.atom.JobTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.JobTime.displayName = 'proto.atom.JobTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.AdsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.atom.AdsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.AdsInfo.displayName = 'proto.atom.AdsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.EntityInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.atom.EntityInfo.repeatedFields_, null);
};
goog.inherits(proto.atom.EntityInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.EntityInfo.displayName = 'proto.atom.EntityInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.Team = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.atom.Team.repeatedFields_, null);
};
goog.inherits(proto.atom.Team, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.Team.displayName = 'proto.atom.Team';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.LiveTeam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.atom.LiveTeam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.LiveTeam.displayName = 'proto.atom.LiveTeam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.SelectedLadyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.atom.SelectedLadyInfo.repeatedFields_, null);
};
goog.inherits(proto.atom.SelectedLadyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.SelectedLadyInfo.displayName = 'proto.atom.SelectedLadyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.atom.LiveJobInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.atom.LiveJobInfo.repeatedFields_, null);
};
goog.inherits(proto.atom.LiveJobInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.atom.LiveJobInfo.displayName = 'proto.atom.LiveJobInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.Conditions.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.Conditions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.Conditions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.Conditions.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    info: jspb.Message.getFieldWithDefault(msg, 2, 0),
    number: jspb.Message.getFieldWithDefault(msg, 3, 0),
    price: jspb.Message.getFieldWithDefault(msg, 4, 0),
    id: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.Conditions}
 */
proto.atom.Conditions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.Conditions;
  return proto.atom.Conditions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.Conditions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.Conditions}
 */
proto.atom.Conditions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.atom.ConditionsType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.atom.ConditionsInfo} */ (reader.readEnum());
      msg.setInfo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.Conditions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.Conditions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.Conditions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.Conditions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInfo();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional ConditionsType type = 1;
 * @return {!proto.atom.ConditionsType}
 */
proto.atom.Conditions.prototype.getType = function() {
  return /** @type {!proto.atom.ConditionsType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.atom.ConditionsType} value
 * @return {!proto.atom.Conditions} returns this
 */
proto.atom.Conditions.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ConditionsInfo info = 2;
 * @return {!proto.atom.ConditionsInfo}
 */
proto.atom.Conditions.prototype.getInfo = function() {
  return /** @type {!proto.atom.ConditionsInfo} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.atom.ConditionsInfo} value
 * @return {!proto.atom.Conditions} returns this
 */
proto.atom.Conditions.prototype.setInfo = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 number = 3;
 * @return {number}
 */
proto.atom.Conditions.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.Conditions} returns this
 */
proto.atom.Conditions.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 price = 4;
 * @return {number}
 */
proto.atom.Conditions.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.Conditions} returns this
 */
proto.atom.Conditions.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 id = 5;
 * @return {number}
 */
proto.atom.Conditions.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.Conditions} returns this
 */
proto.atom.Conditions.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.JobTime.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.JobTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.JobTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.JobTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    index: jspb.Message.getFieldWithDefault(msg, 3, 0),
    registerTime: (f = msg.getRegisterTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.JobTime}
 */
proto.atom.JobTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.JobTime;
  return proto.atom.JobTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.JobTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.JobTime}
 */
proto.atom.JobTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIndex(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegisterTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.JobTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.JobTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.JobTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.JobTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRegisterTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.JobTime.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.JobTime} returns this
*/
proto.atom.JobTime.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.JobTime} returns this
 */
proto.atom.JobTime.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.JobTime.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.JobTime.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.JobTime} returns this
*/
proto.atom.JobTime.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.JobTime} returns this
 */
proto.atom.JobTime.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.JobTime.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 index = 3;
 * @return {number}
 */
proto.atom.JobTime.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.JobTime} returns this
 */
proto.atom.JobTime.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp register_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.JobTime.prototype.getRegisterTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.JobTime} returns this
*/
proto.atom.JobTime.prototype.setRegisterTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.JobTime} returns this
 */
proto.atom.JobTime.prototype.clearRegisterTime = function() {
  return this.setRegisterTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.JobTime.prototype.hasRegisterTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.AdsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.AdsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.AdsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.AdsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    postDeadline: (f = msg.getPostDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    adDeadline: (f = msg.getAdDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    postPicType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    postPicAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    includeCompanyText: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    category: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.AdsInfo}
 */
proto.atom.AdsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.AdsInfo;
  return proto.atom.AdsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.AdsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.AdsInfo}
 */
proto.atom.AdsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPostDeadline(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAdDeadline(value);
      break;
    case 3:
      var value = /** @type {!proto.atom.PostPicType} */ (reader.readEnum());
      msg.setPostPicType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPostPicAmount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCompanyText(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.AdsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.AdsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.AdsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.AdsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostDeadline();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAdDeadline();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPostPicType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPostPicAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIncludeCompanyText();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp post_deadline = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.AdsInfo.prototype.getPostDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.AdsInfo} returns this
*/
proto.atom.AdsInfo.prototype.setPostDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.clearPostDeadline = function() {
  return this.setPostDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.AdsInfo.prototype.hasPostDeadline = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp ad_deadline = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.AdsInfo.prototype.getAdDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.AdsInfo} returns this
*/
proto.atom.AdsInfo.prototype.setAdDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.clearAdDeadline = function() {
  return this.setAdDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.AdsInfo.prototype.hasAdDeadline = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PostPicType post_pic_type = 3;
 * @return {!proto.atom.PostPicType}
 */
proto.atom.AdsInfo.prototype.getPostPicType = function() {
  return /** @type {!proto.atom.PostPicType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.atom.PostPicType} value
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.setPostPicType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 post_pic_amount = 4;
 * @return {number}
 */
proto.atom.AdsInfo.prototype.getPostPicAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.setPostPicAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool include_company_text = 5;
 * @return {boolean}
 */
proto.atom.AdsInfo.prototype.getIncludeCompanyText = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.setIncludeCompanyText = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int64 category = 6;
 * @return {number}
 */
proto.atom.AdsInfo.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.AdsInfo} returns this
 */
proto.atom.AdsInfo.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.atom.EntityInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.EntityInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.EntityInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.EntityInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.EntityInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    address: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timeInfoList: jspb.Message.toObjectList(msg.getTimeInfoList(),
    proto.atom.JobTime.toObject, includeInstance),
    totalHr: jspb.Message.getFieldWithDefault(msg, 4, 0),
    category: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.EntityInfo}
 */
proto.atom.EntityInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.EntityInfo;
  return proto.atom.EntityInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.EntityInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.EntityInfo}
 */
proto.atom.EntityInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = new proto.atom.JobTime;
      reader.readMessage(value,proto.atom.JobTime.deserializeBinaryFromReader);
      msg.addTimeInfo(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalHr(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.EntityInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.EntityInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.EntityInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.EntityInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimeInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.atom.JobTime.serializeBinaryToWriter
    );
  }
  f = message.getTotalHr();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string city_code = 1;
 * @return {string}
 */
proto.atom.EntityInfo.prototype.getCityCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.EntityInfo} returns this
 */
proto.atom.EntityInfo.prototype.setCityCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.atom.EntityInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.EntityInfo} returns this
 */
proto.atom.EntityInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated JobTime time_info = 3;
 * @return {!Array<!proto.atom.JobTime>}
 */
proto.atom.EntityInfo.prototype.getTimeInfoList = function() {
  return /** @type{!Array<!proto.atom.JobTime>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.atom.JobTime, 3));
};


/**
 * @param {!Array<!proto.atom.JobTime>} value
 * @return {!proto.atom.EntityInfo} returns this
*/
proto.atom.EntityInfo.prototype.setTimeInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.atom.JobTime=} opt_value
 * @param {number=} opt_index
 * @return {!proto.atom.JobTime}
 */
proto.atom.EntityInfo.prototype.addTimeInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.atom.JobTime, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.atom.EntityInfo} returns this
 */
proto.atom.EntityInfo.prototype.clearTimeInfoList = function() {
  return this.setTimeInfoList([]);
};


/**
 * optional int64 total_hr = 4;
 * @return {number}
 */
proto.atom.EntityInfo.prototype.getTotalHr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.EntityInfo} returns this
 */
proto.atom.EntityInfo.prototype.setTotalHr = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 category = 5;
 * @return {number}
 */
proto.atom.EntityInfo.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.EntityInfo} returns this
 */
proto.atom.EntityInfo.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.atom.Team.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.Team.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.Team.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.Team} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.Team.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    objectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isRegister: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    conditionList: jspb.Message.toObjectList(msg.getConditionList(),
    proto.atom.Conditions.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.Team}
 */
proto.atom.Team.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.Team;
  return proto.atom.Team.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.Team} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.Team}
 */
proto.atom.Team.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRegister(value);
      break;
    case 5:
      var value = new proto.atom.Conditions;
      reader.readMessage(value,proto.atom.Conditions.deserializeBinaryFromReader);
      msg.addCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.Team.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.Team.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.Team} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.Team.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getObjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsRegister();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getConditionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.atom.Conditions.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.atom.Team.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.Team} returns this
 */
proto.atom.Team.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string object_id = 2;
 * @return {string}
 */
proto.atom.Team.prototype.getObjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.Team} returns this
 */
proto.atom.Team.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_url = 3;
 * @return {string}
 */
proto.atom.Team.prototype.getProfileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.Team} returns this
 */
proto.atom.Team.prototype.setProfileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_register = 4;
 * @return {boolean}
 */
proto.atom.Team.prototype.getIsRegister = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.atom.Team} returns this
 */
proto.atom.Team.prototype.setIsRegister = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated Conditions condition = 5;
 * @return {!Array<!proto.atom.Conditions>}
 */
proto.atom.Team.prototype.getConditionList = function() {
  return /** @type{!Array<!proto.atom.Conditions>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.atom.Conditions, 5));
};


/**
 * @param {!Array<!proto.atom.Conditions>} value
 * @return {!proto.atom.Team} returns this
*/
proto.atom.Team.prototype.setConditionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.atom.Conditions=} opt_value
 * @param {number=} opt_index
 * @return {!proto.atom.Conditions}
 */
proto.atom.Team.prototype.addCondition = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.atom.Conditions, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.atom.Team} returns this
 */
proto.atom.Team.prototype.clearConditionList = function() {
  return this.setConditionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.LiveTeam.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.LiveTeam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.LiveTeam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.LiveTeam.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    objectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    checkInTime: (f = msg.getCheckInTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.LiveTeam}
 */
proto.atom.LiveTeam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.LiveTeam;
  return proto.atom.LiveTeam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.LiveTeam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.LiveTeam}
 */
proto.atom.LiveTeam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileUrl(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCheckInTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.LiveTeam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.LiveTeam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.LiveTeam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.LiveTeam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getObjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCheckInTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.atom.LiveTeam.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.LiveTeam} returns this
 */
proto.atom.LiveTeam.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string object_id = 2;
 * @return {string}
 */
proto.atom.LiveTeam.prototype.getObjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveTeam} returns this
 */
proto.atom.LiveTeam.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_url = 3;
 * @return {string}
 */
proto.atom.LiveTeam.prototype.getProfileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveTeam} returns this
 */
proto.atom.LiveTeam.prototype.setProfileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp check_in_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.LiveTeam.prototype.getCheckInTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.LiveTeam} returns this
*/
proto.atom.LiveTeam.prototype.setCheckInTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.LiveTeam} returns this
 */
proto.atom.LiveTeam.prototype.clearCheckInTime = function() {
  return this.setCheckInTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.LiveTeam.prototype.hasCheckInTime = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.atom.SelectedLadyInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.SelectedLadyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.SelectedLadyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.SelectedLadyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.SelectedLadyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    conditionIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.SelectedLadyInfo}
 */
proto.atom.SelectedLadyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.SelectedLadyInfo;
  return proto.atom.SelectedLadyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.SelectedLadyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.SelectedLadyInfo}
 */
proto.atom.SelectedLadyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectId(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setConditionIdList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.SelectedLadyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.SelectedLadyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.SelectedLadyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.SelectedLadyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConditionIdList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional string object_id = 1;
 * @return {string}
 */
proto.atom.SelectedLadyInfo.prototype.getObjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.SelectedLadyInfo} returns this
 */
proto.atom.SelectedLadyInfo.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int64 condition_id = 2;
 * @return {!Array<number>}
 */
proto.atom.SelectedLadyInfo.prototype.getConditionIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.atom.SelectedLadyInfo} returns this
 */
proto.atom.SelectedLadyInfo.prototype.setConditionIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.atom.SelectedLadyInfo} returns this
 */
proto.atom.SelectedLadyInfo.prototype.addConditionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.atom.SelectedLadyInfo} returns this
 */
proto.atom.SelectedLadyInfo.prototype.clearConditionIdList = function() {
  return this.setConditionIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.atom.LiveJobInfo.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.atom.LiveJobInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.atom.LiveJobInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.atom.LiveJobInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.LiveJobInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    timeIndex: jspb.Message.getFieldWithDefault(msg, 6, 0),
    totalTimeLength: jspb.Message.getFieldWithDefault(msg, 7, 0),
    readyPerson: jspb.Message.getFieldWithDefault(msg, 8, 0),
    teamsList: jspb.Message.toObjectList(msg.getTeamsList(),
    proto.atom.LiveTeam.toObject, includeInstance),
    cityCode: jspb.Message.getFieldWithDefault(msg, 10, ""),
    address: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.atom.LiveJobInfo}
 */
proto.atom.LiveJobInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.atom.LiveJobInfo;
  return proto.atom.LiveJobInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.atom.LiveJobInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.atom.LiveJobInfo}
 */
proto.atom.LiveJobInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeIndex(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalTimeLength(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReadyPerson(value);
      break;
    case 9:
      var value = new proto.atom.LiveTeam;
      reader.readMessage(value,proto.atom.LiveTeam.deserializeBinaryFromReader);
      msg.addTeams(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityCode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.atom.LiveJobInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.atom.LiveJobInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.atom.LiveJobInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.atom.LiveJobInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTimeIndex();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalTimeLength();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getReadyPerson();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.atom.LiveTeam.serializeBinaryToWriter
    );
  }
  f = message.getCityCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 job_id = 1;
 * @return {number}
 */
proto.atom.LiveJobInfo.prototype.getJobId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setJobId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.atom.LiveJobInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tracking_num = 3;
 * @return {string}
 */
proto.atom.LiveJobInfo.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.LiveJobInfo.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.LiveJobInfo} returns this
*/
proto.atom.LiveJobInfo.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.LiveJobInfo.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.atom.LiveJobInfo.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.atom.LiveJobInfo} returns this
*/
proto.atom.LiveJobInfo.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.atom.LiveJobInfo.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 time_index = 6;
 * @return {number}
 */
proto.atom.LiveJobInfo.prototype.getTimeIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setTimeIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 total_time_length = 7;
 * @return {number}
 */
proto.atom.LiveJobInfo.prototype.getTotalTimeLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setTotalTimeLength = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 ready_person = 8;
 * @return {number}
 */
proto.atom.LiveJobInfo.prototype.getReadyPerson = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setReadyPerson = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated LiveTeam teams = 9;
 * @return {!Array<!proto.atom.LiveTeam>}
 */
proto.atom.LiveJobInfo.prototype.getTeamsList = function() {
  return /** @type{!Array<!proto.atom.LiveTeam>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.atom.LiveTeam, 9));
};


/**
 * @param {!Array<!proto.atom.LiveTeam>} value
 * @return {!proto.atom.LiveJobInfo} returns this
*/
proto.atom.LiveJobInfo.prototype.setTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.atom.LiveTeam=} opt_value
 * @param {number=} opt_index
 * @return {!proto.atom.LiveTeam}
 */
proto.atom.LiveJobInfo.prototype.addTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.atom.LiveTeam, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.clearTeamsList = function() {
  return this.setTeamsList([]);
};


/**
 * optional string city_code = 10;
 * @return {string}
 */
proto.atom.LiveJobInfo.prototype.getCityCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setCityCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string address = 11;
 * @return {string}
 */
proto.atom.LiveJobInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.atom.LiveJobInfo} returns this
 */
proto.atom.LiveJobInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * @enum {number}
 */
proto.atom.JobType = {
  JT_DEFAULT: 0,
  JT_ENTITY: 1,
  JT_AD: 2
};

/**
 * @enum {number}
 */
proto.atom.PriceType = {
  PT_DEFAULT: 0,
  PT_NEED: 1,
  PT_FREE: 2
};

/**
 * @enum {number}
 */
proto.atom.ConditionsType = {
  C_DEFAULT: 0,
  C_ADD: 1,
  C_REQUIRE: 2
};

/**
 * @enum {number}
 */
proto.atom.ConditionsInfo = {
  CI_DEFAULT: 0,
  CI_TOPLADY: 1,
  CI_IG_FOLLOW: 2,
  CI_IG_TRACK: 3
};

/**
 * @enum {number}
 */
proto.atom.PostPicType = {
  PPT_DEFAULT: 0,
  PPT_LESS: 1,
  PPT_TOTAL: 2
};

/**
 * @enum {number}
 */
proto.atom.JobStatus = {
  JS_CLOSE: 0,
  JS_OPEN: 1,
  JS_ALL: 2
};

/**
 * @enum {number}
 */
proto.atom.Limit = {
  SIZE_0: 0,
  SIZE_10: 10,
  SIZE_25: 25,
  SIZE_50: 50,
  SIZE_100: 100
};

/**
 * @enum {number}
 */
proto.atom.PersonalJobType = {
  PJ_DEFAULT: 0,
  PJ_CHECKPENDING: 1,
  PJ_REGISTERSUCCESS: 2,
  PJ_CHECKIN: 3,
  PJ_HISTORY: 4
};

goog.object.extend(exports, proto.atom);
